import { render, staticRenderFns } from "./ANxADxSpecificPage.vue?vue&type=template&id=31cb77c9"
import script from "./ANxADxSpecificPage.vue?vue&type=script&lang=js"
export * from "./ANxADxSpecificPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports